import React from 'react';
import { SearchInput } from 'react-admin';

import GetAppIcon from '@mui/icons-material/GetApp';

import CostRow from './CostRow';
import List, { ListActions } from '../common/views/List';
import IconButton from '../common/buttons/IconButton';
import CostDashboardWidget from './CostDashboardWidget';

import { API_URL } from '../../services/settings';


const CostListActions = (props) => (
    <ListActions {...props}>
        <IconButton icon={<GetAppIcon />} component="a" href={`${API_URL}/costs/export.xls`}>Export</IconButton>
    </ListActions>
);

const CostFilters = [
    <SearchInput source="q" alwaysOn />,
];

const filterDefaultValues = {
};

const CostList = props => (
    <>
        <CostDashboardWidget />
        <List
            {...props}
            filters={CostFilters}
            filterDefaultValues={filterDefaultValues}
            actions={<CostListActions />}
            exporter={false}
        >
            <CostRow />
        </List>
    </>
);

export default CostList;